import { IEnvironment } from "../interfaces/env/environment.model";
import { API } from "./apis.enum";

const gateway = 'https://api-dev.service.ford.com/agenda/gateway/';
const bff = 'https://api-dev.service.ford.com/agenda/osb/';
const agendaFordPassUrl = 'https://saperksqa.agenda.ford.com/fordpass/';

const getRoute = (path: string, isPublic = false, isUseGateway = true): string => {
  const contextPath = isPublic ? `${path}/api/public` : `${path}`;
  const baseUrl = isUseGateway ? gateway : bff;
  return `${baseUrl}${contextPath}`;
};

const authentication = {
  clientId: 'bb97acd7-ee01-47c6-abbc-9e7c1bbe2a05',
  redirectUri: 'https://fpdev.agenda.ford.com/',
  scopes: [
    'openid',
    'profile'
  ],
};

const msalConfig = {
  clientId: authentication.clientId,
  authority: '',
  authorityDomain: 'loginqa.ford.com',
  tenantId: 'e75ff8bf-6627-43e3-b410-9fc74d252d29',
  redirectUri: authentication.redirectUri,
  fordApplicationId: '9ABD5361-34EA-11E7-AA90-000D3A196736',
  countryCode: 'BRA',
  policyPrefix: 'B2C_1A_qa_SignInSignUp_',
  policyPrefixPasswordChange: 'B2C_1A_qa_ProfileEditCombined_',
};

// TODO: quero testar sem essa config
const apiConfig = Object.values(API).reduce(
  (acc, apiPath) => {
    acc[apiPath] = {
      scopes: authentication.scopes,
      uri: getRoute(apiPath),
    };
    return acc;
  },
  {} as Record<string, { scopes: string[]; uri: string }>
);

export const environment: IEnvironment = {
  production: false,
  name: 'dev',
  siteId: '2',
  agendaFordPassUrl,
  project: {
    schedule: 'https://osb.fpdev.agenda.ford.com/#/',
    shell: 'https://fpdev.agenda.ford.com/#/',
    status: 'https://status.fpdev.agenda.ford.com/#/',
    history: 'https://history.fpdev.agenda.ford.com/#/'
  },
  features: {
    newStep3: true
  },
  heremaps: {
    key: 'cyxZaewUpsOXoSTebFx9-j9azuzY4e-CmNdSA9xny78'
  },
  apiConfig,
  msalConfig,
  authentication,
  getRoute
};
